export default __webpack_public_path__ + "static/aws-116b0d268d8b875c6fa55c98cad07302.png";